export default "https://lightningbookassetsdev.blob.core.windows.net/lightning-ui/1.46.0/ui/019d1915a6468334.png"